import { Mail, MapPin, Phone } from "lucide-react";
import Seo from "../components/Seo";
import PageHeader from "../components/PageHeader";
import EnquiryForm from "../components/EnquiryForm";
import MapBlock from "../components/MapBlock";
import { Reveal } from "../components/Motion";
import { WhatsAppIcon } from "../components/Brand";
import { SITE, waLink } from "../lib/site";

import { pick } from "../lib/leadFields";

const FIELDS = pick("name", "phone", "whatsapp", "email", "company", "business_type", { name: "city", label: "City / Town" }, "state", "product", "quantity", { name: "message", label: "Message", type: "textarea", full: true, required: true });

const CARDS = [
  { icon: Phone, label: "Call", value: SITE.headOfficeDisplay, href: `tel:+91${SITE.headOffice}`, id: "phone" },
  { icon: WhatsAppIcon, label: "WhatsApp", value: SITE.phoneDisplay, href: waLink(), id: "whatsapp" },
  { icon: Mail, label: "Email", value: SITE.email, href: `mailto:${SITE.email}`, id: "email" },
  { icon: MapPin, label: "Location", value: SITE.location, href: SITE.mapLink, id: "location" },
];

export default function Contact() {
  return (
    <>
      <Seo title="Contact Us" description="Contact MHM SUPER ADBLUE in Haldia, West Bengal. Call or WhatsApp +91 89721 36750 or email mhmsuperadblue@gmail.com." />
      <PageHeader testid="contact-header" eyebrow="Contact" lines={["Let's keep", { text: "you moving.", cls: "text-brand" }]} intro="Call, WhatsApp or write to us — we're happy to help with products, pricing and supply." />
      <section className="bg-[var(--paper)] py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {CARDS.map(({ icon: Icon, label, value, href, id }, i) => (
              <Reveal key={id} delay={i * 0.06}>
                <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={`contact-card-${id}`} className="group flex h-full flex-col rounded-[22px] border border-navy/10 bg-white p-6 transition-[border-color,transform] hover:-translate-y-1 hover:border-brand">
                  <span className="grid h-12 w-12 place-items-center rounded-xl bg-navy text-brand transition-colors group-hover:bg-brand group-hover:text-white"><Icon className="h-5 w-5" /></span>
                  <p className="mt-6 eyebrow text-slate-500">{label}</p>
                  <p className="mt-2 break-words font-semibold text-navy">{value}</p>
                </a>
              </Reveal>
            ))}
          </div>
          <div className="mt-12 grid gap-10 lg:grid-cols-12">
            <Reveal className="lg:col-span-6">
              <div className="rounded-[26px] border border-navy/10 bg-white p-6 sm:p-10">
                <h2 className="font-display text-4xl font-extrabold uppercase text-navy">Send a message</h2>
                <p className="mt-2 mb-8 text-slate-600">We usually reply within a working day.</p>
                <EnquiryForm type="contact" testPrefix="contact" fields={FIELDS} submitLabel="Send message" />
              </div>
            </Reveal>
            <Reveal delay={0.1} className="lg:col-span-6">
              <MapBlock tall />
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
